module.exports = __webpack_public_path__ + "media/images/proposito-logo-horizontal-white-768x132-d5087f93c9350e091493e8aaefafb0ad.png";